import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getAllData() {
	const companyId = getCompanyId()
	const { data, error } = await supabase.from('progresscheck').select().eq('companyId', companyId)

	if (error) {
		throw new Error(`Failed to fetch progress check data: ${error.message}`)
	}

	return data
}

export async function getDataWithType(type) {
	const companyId = getCompanyId()
	const { data, error } = await supabase
		.from('progresscheck')
		.select()
		.eq('type', type)
		.eq('companyId', companyId)
		.order('order', { ascending: true })

	if (error) {
		throw new Error(`Failed to fetch progress check data by type: ${error.message}`)
	}

	return data
}

export async function addData(adata) {
	const companyId = getCompanyId()
	adata = { ...adata, companyId: companyId }

	const { data, error } = await supabase.from('progresscheck').insert(adata).select()

	if (error) {
		throw new Error(`Failed to add progress check: ${error.message}`)
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('progresscheck').delete().eq('id', id)
	if (error) {
		throw new Error(`Failed to delete progress check: ${error.message}`)
	}

	return data
}
